import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4c6e7ad8&scoped=true&lang=html&"
import script from "./regularCustomDetail.js?vue&type=script&lang=js&"
export * from "./regularCustomDetail.js?vue&type=script&lang=js&"
import style0 from "./regularCustomDetail.styl?vue&type=style&index=0&id=4c6e7ad8&lang=stylus&scoped=true&"
import style1 from "./resetStyle.styl?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6e7ad8",
  null
  
)

export default component.exports